<div class="fx-table-container">
  <div class="table-header">
    <div class="header-left">
      <h2 class="table-title">{{ title | translate }}</h2>
      <span class="total-badge">{{ 'table.total' | translate }} {{ totalItems }} </span>
    </div>

    <div class="header-right">
      @if (showDateFilter) {
      <div class="date-filter-group">
        <div class="filter-group">
          <svg class="filter-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
          <select [(ngModel)]="filterYear" (change)="onDateFilterChange()">
            @for (year of years; track $index) {
            <option [value]="year">{{ year }}</option>
            }
          </select>
        </div>
        <div class="filter-group">
          <svg class="filter-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
          <select [(ngModel)]="filterMonth" (change)="onDateFilterChange()">
            @for (month of months; track $index) {
            <option [value]="month.value">{{ 'month.' + month.value | translate }}</option>
            }
          </select>
        </div>
      </div>}

      @if (showDateRangeFilter) {
      <div class="filter-group">
        <svg class="filter-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <select [(ngModel)]="filterDateRange" (change)="onDateRangeChange()">
          <option value="">{{ 'table.allTime' | translate }}</option>
          @for (range of dateRangeOptions; track $index) {
          <option [value]="range.value">{{ ('table.range' + (range.value.charAt(0).toUpperCase() +
            range.value.slice(1))) | translate }}</option>
          }
        </select>
      </div>}

      @if (showAlphabetFilter) {
      <div class="filter-group">
        <svg class="filter-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M4 7h16M4 12h16M4 17h16"></path>
        </svg>
        <select [(ngModel)]="filterAlphabet" (change)="onAlphabetFilterChange()">
          <option value="">{{ 'table.allAlphabets' | translate }}</option>
          @for (opt of alphabetOptions; track $index) {
          <option [value]="opt">{{ opt }}</option>
          }
        </select>
      </div>}

      @if (showStatusFilter) {
      <div class="filter-group">
        <svg class="filter-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <select [(ngModel)]="filterStatus" (change)="onStatusFilterChange()">
          <option value="">{{ 'table.allStatus' | translate }}</option>
          @for (status of statusOptions; track $index) {
          <option [value]="status.value">{{ ('table.status' + status.name) | translate }}</option>
          }
        </select>
      </div>}

      @if (showSearch) {
      <div class="search-group">
        <svg class="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <input type="text" [(ngModel)]="searchValue" [placeholder]="'table.search' | translate"
          (keyup.enter)="onSearch()" />
      </div>}
      @if (isImport) {
      <input type="file" #importFile style="display: none" (change)="onFileChange($event)" accept=".xlsx, .xls, .docx" />
      <button
        class="bg-[var(--primary)] h-[40px] text-white px-4 py-2 rounded-lg hover:opacity-90 transition flex items-center gap-2"
        (click)="importFile.click()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-4 h-4">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="17 8 12 3 7 8"></polyline>
          <line x1="12" y1="3" x2="12" y2="15"></line>
        </svg>
        <span>{{ 'table.import' | translate }}</span>
      </button>
      }

      @if (isExport) {
        <button
          class="bg-[#1F3F66] h-[40px] text-white px-4 py-2 rounded-lg hover:opacity-90 transition flex items-center gap-2"
          (click)="onExport()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-4 h-4">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="7 10 12 15 17 10"></polyline>
            <line x1="12" y1="15" x2="12" y2="3"></line>
          </svg>
          <span>{{ 'purchase.export' | translate }}</span>
        </button>
      }

      @if (isCreate) {
      <button class="create-btn" (click)="onCreate()">
        <span class="plus-icon">+</span> {{ 'table.createNew' | translate }}
      </button>}
    </div>
  </div>

  <div class="table-main">
    @if (isLoading) {
    <div class="loading-overlay">
      <app-loading></app-loading>
    </div>
    }

    <div class="table-wrapper" [class.loading-active]="isLoading">
      <table class="w-full">
        <thead>
          @if (columns.length) {
          <tr>
            @for (col of columns; track $index) {
            <th (click)="col.sortable && onSort(col)">
              <div class="th-content">
                {{ col.name | translate }}
                @if(col.sortable) {
                <span class="sort-icon">⇅</span>}
              </div>
            </th>
            }
          </tr>
          }
        </thead>

        <tbody>
          @if (!isLoading && data.length === 0) {
          <tr>
            <td [attr.colspan]="columns.length" class="status-cell no-data">
              {{ 'table.noResults' | translate }} "{{ searchValue }}"
            </td>
          </tr>}

          @for (row of data; track $index) {
          <tr (click)="onRowClick(row)" class="row-data">
            @for (col of columns; track $index) {
            <td>
              @if (col.key !== 'actions') {
              <ng-container>
                @if (col.key !== 'icon' && col.key !== 'image' && col.key !== 'status') {
                <span class="cell-text">{{ getCellValue(row, col.key)
                  }}</span>
                }
                @else if (col.key == 'icon') {
                <img class="h-10 cursor-pointer hover:scale-110 transition-transform"
                  src="{{ getCellValue(row, col.key) }}" alt="Icon"
                  (click)="onImageClick($event, getCellValue(row, col.key))">}
                @else if (col.key == 'image') {
                <img *ngIf="getCellValue(row, col.key)" class="h-16 w-16 object-contain rounded-lg border border-gray-200 cursor-pointer hover:scale-110 transition-transform shadow-sm"
                  [src]="getCellValue(row, col.key)" alt="QR Code"
                  (click)="onImageClick($event, getCellValue(row, col.key))">
                <span *ngIf="!getCellValue(row, col.key)" class="text-gray-400 text-xs">—</span>
                }
                @else if (col.key == 'status') {
                <span [ngClass]="{
      'bg-[#8D6E63]': getCellValue(row, col.key) == '05',
      'bg-[#FFC300]': getCellValue(row, col.key) == '01',
      'bg-[var(--primary)]': getCellValue(row, col.key) == '02',
      'bg-[#C40C0C]': getCellValue(row, col.key) == '03',
      'bg-[#F39C12]': getCellValue(row, col.key) == '04',
    }" class="px-3 py-1 text-xs font-medium rounded-full text-white">
                  {{
                  getCellValue(row, col.key) == '01'
                  ? ('table.statusOpen' | translate)
                  : getCellValue(row, col.key) == '02'
                  ? ('table.statusConfirmed' | translate)
                  : getCellValue(row, col.key) == '03'
                  ? ('table.statusFailed' | translate)
                  : getCellValue(row, col.key) == "04"
                  ? ('table.statusPending' | translate)
                  : getCellValue(row, col.key) == "05"
                  ? ('table.statusReserved' | translate)
                  : ('table.statusOpen' | translate)
                  }}
                </span>}
              </ng-container>
              }
              @else{
              <div class="action-buttons">
                <button class="edit-btn" (click)="onEdit($event, row)" title="Edit">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
                @if (!isEditOnly) {
                <button class="delete-btn" (click)="onDelete($event, row)" title="Delete">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
                }

              </div>
              }
            </td>}
          </tr>
          }

        </tbody>
      </table>
    </div>
  </div>

  <div class="pagination-footer">
    <div style="display: flex; align-items: center; gap: 16px;">
      <select [ngModel]="pageSize" (change)="onPageSizeChange($event)" class="page-size-select">
        @for (size of pageSizeOptions; track $index) {
          <option [value]="size">{{ size }} </option>
        }
      </select>
      <p class="page-info">{{ 'table.page' | translate }} {{ currentPage }} {{ 'table.of' | translate }} {{ totalPages }}</p>
    </div>
    <div class="pagination-controls">
      <button class="nav-btn" [disabled]="currentPage === 1" (click)="onPageChange(currentPage - 1)">
        {{ 'table.previous' | translate }}
      </button>
      <div class="page-numbers">
        @for (page of visiblePages; track $index) {
        <button class="page-num" [class.active]="currentPage === page" [class.ellipsis]="page === '...'"
          [disabled]="page === '...'" (click)="page !== '...' && onPageChange($any(page))">
          {{ page }}
        </button>}
      </div>
      <button class="nav-btn" [disabled]="currentPage === totalPages" (click)="onPageChange(currentPage + 1)">
        {{ 'table.next' | translate }}
      </button>
    </div>
  </div>

  <div class="preview-overlay" *ngIf="isPreviewOpen" (click)="closePreview()">
    <div class="preview-content" (click)="$event.stopPropagation()">
      <button class="preview-close" (click)="closePreview()">&times;</button>
      <img [src]="previewUrl" alt="Large Preview">
    </div>
  </div>

  <div class="st-confirm-overlay" *ngIf="isDeleteConfirmOpen" (click)="cancelDelete()">
    <div class="st-confirm-box st-animate-pop" (click)="$event.stopPropagation()">
      <div class="st-confirm-icon-wrapper">
        <div class="st-confirm-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            <line x1="10" y1="11" x2="10" y2="17"></line>
            <line x1="14" y1="11" x2="14" y2="17"></line>
          </svg>
        </div>
      </div>
      <div class="st-confirm-body">
        <h3 class="st-confirm-title">{{ 'alert.deleteConfirm' | translate }}</h3>
        <p class="st-confirm-subtitle">This action cannot be undone.</p>
      </div>
      <div class="st-confirm-actions">
        <button class="st-confirm-cancel-btn" (click)="cancelDelete()">Cancel</button>
        <button class="st-confirm-delete-btn" (click)="confirmDelete()">Delete</button>
      </div>
    </div>
  </div>

</div>